import { SectionProps } from "react-aria-components";
import { tv } from "tailwind-variants";

export const itemStyles = tv({
  base: "group relative flex items-center gap-8 cursor-default select-none py-1.5 px-2.5 will-change-transform text-sm forced-color-adjust-none",
  variants: {
    isSelected: {
      false:
        "-outline-offset-2",
      true: "bg-blue-600 text-white forced-colors:bg-[Highlight] forced-colors:text-[HighlightText] [&:has(+[data-selected])]:rounded-b-none [&+[data-selected]]:rounded-t-none -outline-offset-4 outline-white dark:outline-white forced-colors:outline-[HighlightText]",
    },
    isDisabled: {
      true: "forced-colors:text-[GrayText]",
    },
  },
});

export interface DropdownSectionProps<T> extends SectionProps<T> {
  title?: string;
}
